export const isDate = (date) =>
    Object.prototype.toString.call(date) === '[object Date]';

/**
 * Formats a date for a `date` field, which only takes `YYYY-MM-DD` and reads it as local time —
 * an ISO string would shift it by the timezone offset.
 */
export const toDateInput = (date) => {
    const pad = (value) => value.toString().padStart(2, '0');

    return [
        date.getFullYear(),
        pad(date.getMonth() + 1),
        pad(date.getDate()),
    ].join('-');
};
